import type { ChatPlugin } from '#types/plugin/chat'
import sierraChat from '#core/integrations/sierra-chat'

export default defineNuxtPlugin<{ chat: ChatPlugin }>(() => {
  const { configLivechat, enableChat } = useFeatureFlags()
  const locale = useLocale()

  if (!enableChat) {
    return {
      provide: {
        chat: {
          open: () => console.warn('Chat is disabled by feature flag'),
          available: ref(false)
        }
      }
    }
  }

  if (configLivechat.enabled && configLivechat.sierraRegions?.includes(locale))
    return sierraChat({ hideLauncher: true })

  // No other chat provider for Vans
  return {
    provide: {
      chat: {
        open: () => console.warn('Chat is not implemented for Vans NORA.'),
        available: ref(false)
      }
    }
  }
})
